export default `/* Ids Multi Select Component */
/* Ids Dropdown Component */
.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

:host([suppress-error-message]) .validation-message {
  display: none;
}

.icon-error-tracker {
  position: absolute;
  color: var(--ids-input-error-tracker-color-background, var(--ids-color-red-60));
  top: 0;
  pointer-events: none;
}
.icon-error-tracker[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

.icon-field-indicator {
  position: absolute;
  top: 0;
  pointer-events: none;
}
.icon-field-indicator[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

.icon-field-indicator-info {
  display: var(--ids-field-indicator-info-visibility, flex);
  align-items: center;
  margin-inline-end: var(--ids-field-indicator-info-margin, var(--ids-space-xs));
  cursor: pointer;
  color: var(--ids-field-indicator-icon-color, --ids-color-info-default);
}

.field-indicator-neutral {
  --ids-field-indicator-icon-color: var(--ids-color-accent-neutral-weak);
}
.field-indicator-neutral .icon-field-indicator {
  color: var(--ids-color-accent-neutral-weak);
}

.field-indicator-info {
  --ids-field-indicator-icon-color: var(--ids-color-info-default);
}
.field-indicator-info .icon-field-indicator {
  color: var(--ids-color-info-default);
}

.field-indicator-success {
  --ids-field-indicator-icon-color: var(--ids-color-success-default);
}
.field-indicator-success .icon-field-indicator {
  color: var(--ids-color-success-default);
}

.field-indicator-caution {
  --ids-field-indicator-icon-color: var(--ids-color-caution-default);
}
.field-indicator-caution .icon-field-indicator {
  color: var(--ids-color-caution-default);
}

.field-indicator-warning {
  --ids-field-indicator-icon-color: var(--ids-color-warning-default);
}
.field-indicator-warning .icon-field-indicator {
  color: var(--ids-color-warning-default);
}

.field-indicator-error {
  --ids-field-indicator-icon-color: var(--ids-color-error-default);
}
.field-indicator-error .icon-field-indicator {
  color: var(--ids-color-error-default);
}

[class*=field-indicator-].has-focus .icon-field-indicator-info {
  display: none;
}

:host {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-background-pressed: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-pressed: var(--ids-color-transparent);
  display: block;
}
:host .ids-dropdown {
  display: inline-block;
  max-width: 100%;
  width: var(--ids-box-dropdown-width, auto);
}

:host([field-indicator]) {
  --ids-field-indicator-info-margin: 0;
}

:host([field-indicator][readonly]),
:host([field-indicator][disabled]) {
  --ids-field-indicator-info-visibility: none;
}

:host([hidden]) {
  display: none;
}

:host([label-position=inline-start]) ids-trigger-field::part(container) {
  justify-content: var(--ids-box-justify-content, flex-start);
}

ids-trigger-field[readonly-background]:not([disabled])::part(input) {
  cursor: var(--ids-cursor-pointer);
}

ids-trigger-field:not([autoselect])::part(input)::selection {
  background-color: var(--ids-color-transparent);
}

.ids-dropdown {
  display: block;
  position: relative;
}
.ids-dropdown ids-trigger-field[size=full] {
  display: block;
}
.ids-dropdown.full {
  display: block;
}
.ids-dropdown.full ids-trigger-field,
.ids-dropdown.full .ids-trigger-field {
  display: block;
}
.ids-dropdown ::slotted(ids-list-box) {
  height: var(--ids-popup-maxheight);
}

.trigger-icon {
  color: var(--ids-dropdown-color-icon);
  margin: 0 0 0 var(--ids-dropdown-space-text);
  position: relative;
  top: 0;
}

:host([mode=light]) .typeahead.is-open ids-trigger-field::part(field-container) {
  background-color: var(--ids-dropdown-typeahead-color-background);
}

:host([dir=rtl]) .trigger-icon {
  margin: 0 var(--ids-dropdown-space-text) 0 0;
}

::slotted(.sub-group) {
  border-top: 1px solid var(--ids-dropdown-separator-color-border);
  padding-top: var(--ids-dropdown-separator-padding);
}

.ids-dropdown.color-variant-borderless ids-trigger-field::part(field-container),
.ids-dropdown.color-variant-in-cell ids-trigger-field::part(field-container) {
  margin: 0;
  border-radius: 0;
}
.ids-dropdown.color-variant-borderless ids-trigger-field::part(label),
.ids-dropdown.color-variant-in-cell ids-trigger-field::part(label) {
  display: none;
}

.ids-dropdown.color-variant-borderless ids-trigger-field::part(container) {
  margin: -1px;
}
.ids-dropdown.color-variant-borderless ids-trigger-field::part(field-container) {
  box-shadow: none !important;
}
.ids-dropdown.color-variant-borderless.is-open .ids-trigger-field-slot-trigger-end {
  margin-block-start: 2px;
}
.ids-dropdown.color-variant-borderless.field-height-lg ids-trigger-field::part(input) {
  padding-inline: 12px;
  height: 50px;
}
.ids-dropdown.color-variant-borderless.field-height-lg.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
}
.ids-dropdown.color-variant-borderless.field-height-md ids-trigger-field::part(input) {
  padding-inline: 13px;
  height: 40px;
}
.ids-dropdown.color-variant-borderless.field-height-md.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 10px;
}
.ids-dropdown.color-variant-borderless.field-height-sm ids-trigger-field::part(input) {
  padding-inline: 9px;
  height: 35px;
}
.ids-dropdown.color-variant-borderless.field-height-sm.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
}
.ids-dropdown.color-variant-borderless.field-height-xs ids-trigger-field::part(input) {
  padding-inline: 5px;
  height: 30px;
}
.ids-dropdown.color-variant-borderless.field-height-xs.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -2px;
}
.ids-dropdown.color-variant-borderless.field-height-xxs ids-trigger-field::part(input) {
  padding-inline: 3px;
  height: 30px;
}
.ids-dropdown.color-variant-borderless.field-height-xxs.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -1px;
  margin-block-start: -2px;
}

:host([combobox]) .ids-dropdown.color-variant-borderless .ids-trigger-field-slot-trigger-end {
  display: flex;
  align-items: center;
  margin-block-start: 2px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-lg .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
  height: 48px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-md .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -1px;
  height: 39px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-sm .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -5px;
  height: 33px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-xs .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -10px;
  height: 29px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-xxs .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -10px;
  margin-block-start: 0;
}

.ids-dropdown.color-variant-in-cell ids-trigger-field::part(container) {
  margin: 1px 0;
}

.ids-dropdown.color-variant-module-nav {
  color: var(--ids-module-nav-search-input-text-color);
  display: block;
  margin-block-end: 0;
}
.ids-dropdown.color-variant-module-nav ::slotted(ids-list-box) {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-dropdown.color-variant-module-nav ::slotted(ids-list-box-option) {
  color: inherit;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(field-container) {
  background-color: var(--ids-module-nav-input-bg-color);
  border-radius: var(--ids-module-nav-common-border-radius);
  border: var(--ids-module-nav-input-border-width) solid var(--ids-module-nav-input-border-color);
  box-shadow: none;
  color: inherit;
  overflow: hidden;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:hover::part(field-container) {
  background-color: var(--ids-module-nav-input-hover-bg-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:active::part(field-container) {
  background-color: var(--ids-module-nav-item-selected-bg-color);
  border-color: var(--ids-module-nav-item-selected-text-color);
  color: var(--ids-module-nav-item-selected-text-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:focus-within::part(field-container) {
  background-color: var(--ids-module-nav-input-focus-bg-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input) {
  background-color: var(--ids-color-transparent);
  color: inherit;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(trigger-button) {
  background-color: var(--ids-color-transparent);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input::placeholder) {
  color: var(--ids-module-nav-search-input-placeholder-text-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input:active) {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-dropdown.color-variant-module-nav ids-dropdown-list::part(dropdown-list) {
  max-width: var(--ids-module-nav-expanded-size);
  width: calc(var(--ids-module-nav-switcher-dropdown-width) + var(--ids-module-nav-switcher-button-gutter-size) + var(--ids-module-nav-switcher-button-size));
}
.ids-dropdown.color-variant-module-nav ids-list-box-option {
  min-height: var(--ids-module-nav-item-height);
}
.ids-dropdown.color-variant-module-nav .fieldset {
  display: contents;
}
.ids-dropdown.color-variant-module-nav .ids-input-field {
  padding-inline-start: var(--ids-module-nav-item-expanded-icon-text-space-size);
}

:host ids-dropdown-list {
  max-width: var(--ids-input-width-40);
}

:host([size=xs]) ids-dropdown-list {
  max-width: var(--ids-input-width-10);
}

:host([size=sm]) ids-dropdown-list {
  max-width: var(--ids-input-width-20);
}

:host([size=mm]) ids-dropdown-list {
  max-width: var(--ids-input-width-30);
}

:host([size=md]) ids-dropdown-list {
  max-width: var(--ids-input-width-40);
}

:host([size=lg]) ids-dropdown-list {
  max-width: var(--ids-input-width-50);
}

:host([size=full]) ids-dropdown-list {
  max-width: var(--ids-input-width-full);
}

:host ids-dropdown-list,
:host([size=full]) {
  width: var(--ids-input-width-full);
}

:host([list]:not([disabled])) {
  cursor: var(--ids-cursor-pointer);
}

:host([auto-size=true]) ids-trigger-field::part(input) {
  padding-inline-end: 0;
}

.ids-checkbox {
  margin-bottom: 0;
}

ids-trigger-field ids-tag {
  align-self: center;
  display: flex;
  margin-top: var(--ids-space-2xs);
  margin-inline-start: var(--ids-space-2xs);
  max-width: 100%;
}
ids-trigger-field ids-tag[disabled]::part(tag) {
  cursor: var(--ids-cursor-default);
}
ids-trigger-field ids-tag ids-icon {
  padding-left: 6px;
  padding-right: 1px;
  width: 12px;
  top: 0;
}

:host([tags]),
:host(:not([typeahead]):not([tags])) {
  --ids-checkbox-padding-inline-start: 18px;
}
:host([tags]) ids-trigger-field::part(content-area),
:host(:not([typeahead]):not([tags])) ids-trigger-field::part(content-area) {
  display: flex;
  width: calc(100% - 38px);
  flex-wrap: wrap;
}
:host([tags]) ids-trigger-field::part(input),
:host(:not([typeahead]):not([tags])) ids-trigger-field::part(input) {
  opacity: 0;
  color: transparent;
  width: 0;
  padding: 0;
  flex: 1;
}
:host([tags]) ids-trigger-field::part(input)::placeholder,
:host(:not([typeahead]):not([tags])) ids-trigger-field::part(input)::placeholder {
  visibility: hidden;
}
:host([tags]) ids-trigger-field::part(input)::selection,
:host(:not([typeahead]):not([tags])) ids-trigger-field::part(input)::selection {
  color: var(--ids-color-transparent);
  background: var(--ids-color-transparent);
}
:host([tags]) ids-trigger-field ids-text,
:host(:not([typeahead]):not([tags])) ids-trigger-field ids-text {
  max-width: 100%;
}
:host([tags]) ids-trigger-field ids-text.placeholder,
:host(:not([typeahead]):not([tags])) ids-trigger-field ids-text.placeholder {
  color: var(--ids-multiselect-section-header-color);
}
:host([tags]) ids-trigger-field ids-text::part(text),
:host(:not([typeahead]):not([tags])) ids-trigger-field ids-text::part(text) {
  padding-inline-start: var(--ids-space-xs);
}
:host([tags]) ids-trigger-field[compact] ids-text::part(text), :host([tags]) ids-trigger-field[field-height=xs] ids-text::part(text),
:host(:not([typeahead]):not([tags])) ids-trigger-field[compact] ids-text::part(text),
:host(:not([typeahead]):not([tags])) ids-trigger-field[field-height=xs] ids-text::part(text) {
  padding-inline-start: var(--ids-space-2xs);
  font-size: var(--ids-multiselect-font-size);
}

:host(:not([tags])) ids-trigger-field ids-text.placeholder {
  color: var(--ids-multiselect-section-header-color);
}
:host(:not([tags])) ids-trigger-field ids-text.placeholder::part(text) {
  padding-inline-start: 0;
}

:host(.datagrid-editor) ids-trigger-field ids-text {
  margin-inline-start: 5px;
}

:host(:not([disabled])) .has-value ids-trigger-field::part(field-container) {
  cursor: var(--ids-cursor-pointer);
}

:host([disabled]) ids-trigger-field::part(field-container) {
  pointer-events: none;
}

:host .trigger-icon,
:host ids-trigger-button ids-icon {
  color: var(--ids-multiselect-dropdown-icon-color);
}

.is-open ids-trigger-field::part(field-container) {
  box-shadow: var(--ids-multiselect-dropdown-box-shadow);
}
.is-open ids-trigger-field::part(field-container):not(.error) {
  background-color: var(--ids-multiselect-open-background-color);
  border: var(--ids-multiselect-border-open);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtbXVsdGlzZWxlY3QiLCJzb3VyY2VzIjpbImlkcy1tdWx0aXNlbGVjdC5zY3NzIiwiLi4vaWRzLWRyb3Bkb3duL2lkcy1kcm9wZG93bi5zY3NzIiwiLi4vLi4vdGhlbWVzL21peGlucy9pZHMtdmFsaWRhdGlvbi1taXhpbi5zY3NzIiwiLi4vLi4vdGhlbWVzL21peGlucy9pZHMtY29yZS1taXhpbnMuc2NzcyIsIi4uLy4uL3RoZW1lcy9taXhpbnMvaWRzLWVycm9yLXRyYWNrZXItbWl4aW4uc2NzcyIsIi4uLy4uL3RoZW1lcy9taXhpbnMvaWRzLWZpZWxkLWluZGljYXRvci1taXhpbi5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FDQUE7QUNFQTtFQ1FFO0VBQ0E7RUROQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFOztBQUVBO0VBQ0U7O0FBSUo7RUFDRTs7QUFFQTtFQUNFOztBQUlKO0VBQ0U7O0FBRUE7RUFDRTs7QUFJSjtFQUNFOztBQUVBO0VBQ0U7O0FBSUo7RUFDRTs7QUFFQTtFQUNFOztBQUlKO0VBQ0U7OztBQUtGO0VBQ0U7OztBRXBFSjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTs7O0FDUko7RUFDRTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBOzs7QUFJSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7OztBQW9CRjtFQWZFOztBQVNBO0VBQ0U7OztBQVNKO0VBbkJFOztBQVNBO0VBQ0U7OztBQWFKO0VBdkJFOztBQVNBO0VBQ0U7OztBQWlCSjtFQTNCRTs7QUFTQTtFQUNFOzs7QUFxQko7RUEvQkU7O0FBU0E7RUFDRTs7O0FBeUJKO0VBbkNFOztBQVNBO0VBQ0U7OztBQThCRjtFQUNFOzs7QUoxREo7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUVBOztBQUVBO0VBQ0U7RUFDQTtFQUNBOzs7QUFJSjtFQUNFOzs7QUFHRjtBQUFBO0VBRUU7OztBQUdGO0VBQ0U7OztBQUlBO0VBQ0U7OztBQUlKO0VBQ0U7OztBQUlBO0VBQ0U7OztBQUtKO0VBQ0U7RUFDQTs7QUFHRTtFQUNFOztBQUlKO0VBQ0U7O0FBRUE7QUFBQTtFQUVFOztBQUlKO0VBQ0U7OztBQUtKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUlBO0VBQ0U7OztBQUlKO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7O0FBTUE7QUFBQTtFQUNFO0VBQ0E7O0FBR0Y7QUFBQTtFQUNFOzs7QUFNRjtFQUNFOztBQUdGO0VBQ0U7O0FBSUE7RUFDRTs7QUFLRjtFQUNFO0VBQ0E7O0FBSUE7RUFDRTs7QUFNSjtFQUNFO0VBQ0E7O0FBSUE7RUFDRTs7QUFNSjtFQUNFO0VBQ0E7O0FBSUE7RUFDRTs7QUFNSjtFQUNFO0VBQ0E7O0FBSUE7RUFDRTs7QUFNSjtFQUNFO0VBQ0E7O0FBSUE7RUFDRTtFQUNBOzs7QUFRSjtFQUNFO0VBQ0E7RUFDQTs7QUFJQTtFQUNFO0VBQ0E7O0FBS0Y7RUFDRTtFQUNBOztBQUtGO0VBQ0U7RUFDQTs7QUFLRjtFQUNFO0VBQ0E7O0FBS0Y7RUFDRTtFQUNBOzs7QUFRTjtFQUNFOzs7QUFLSjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7QUFHRjtFQUNFOztBQUdGO0VBQ0U7RUFDQTs7QUFHRjtFQUNFOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFOztBQUdGO0VBQ0U7OztBQUtKO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0FBQUE7RUFFRTs7O0FBSUY7RUFDRTs7O0FBSUE7RUFDRTs7O0FEbldKO0VBQ0U7OztBQUlBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7OztBQUtOO0FBQUE7RUFFRTs7QUFHRTtBQUFBO0VBQ0U7RUFDQTtFQUNBOztBQUdGO0FBQUE7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0FBQUE7RUFDRTs7QUFHRjtBQUFBO0VBQ0U7RUFDQTs7QUFJSjtBQUFBO0VBQ0U7O0FBRUE7QUFBQTtFQUNFOztBQUdGO0FBQUE7RUFDRTs7QUFNRjtBQUFBO0FBQUE7RUFDRTtFQUNBOzs7QUFPTjtFQUNFOztBQUVBO0VBQ0U7OztBQU1KO0VBQ0U7OztBQU9FO0VBQ0U7OztBQVFKO0VBQ0U7OztBQU1KO0FBQUE7RUFFRTs7O0FBS0Y7RUFDRTs7QUFFQTtFQUNFO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBJZHMgTXVsdGkgU2VsZWN0IENvbXBvbmVudCAqL1xuQHVzZSAnLi4vaWRzLWRyb3Bkb3duL2lkcy1kcm9wZG93bicgYXMgKjtcblxuLmlkcy1jaGVja2JveCB7XG4gIG1hcmdpbi1ib3R0b206IDA7XG59XG5cbmlkcy10cmlnZ2VyLWZpZWxkIHtcbiAgaWRzLXRhZyB7XG4gICAgYWxpZ24tc2VsZjogY2VudGVyO1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgbWFyZ2luLXRvcDogdmFyKC0taWRzLXNwYWNlLTJ4cyk7XG4gICAgbWFyZ2luLWlubGluZS1zdGFydDogdmFyKC0taWRzLXNwYWNlLTJ4cyk7XG4gICAgbWF4LXdpZHRoOiAxMDAlO1xuXG4gICAgJltkaXNhYmxlZF06OnBhcnQodGFnKSB7XG4gICAgICBjdXJzb3I6IHZhcigtLWlkcy1jdXJzb3ItZGVmYXVsdCk7XG4gICAgfVxuXG4gICAgaWRzLWljb257XG4gICAgICBwYWRkaW5nLWxlZnQ6IDZweDtcbiAgICAgIHBhZGRpbmctcmlnaHQ6IDFweDtcbiAgICAgIHdpZHRoOiAxMnB4O1xuICAgICAgdG9wOiAwO1xuICAgIH1cbiAgfVxufVxuXG46aG9zdChbdGFnc10pLFxuOmhvc3QoOm5vdChbdHlwZWFoZWFkXSk6bm90KFt0YWdzXSkpIHtcbiAgLS1pZHMtY2hlY2tib3gtcGFkZGluZy1pbmxpbmUtc3RhcnQ6IDE4cHg7XG5cbiAgaWRzLXRyaWdnZXItZmllbGQge1xuICAgICY6OnBhcnQoY29udGVudC1hcmVhKSB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgd2lkdGg6IGNhbGMoMTAwJSAtIDM4cHgpO1xuICAgICAgZmxleC13cmFwOiB3cmFwO1xuICAgIH1cblxuICAgICY6OnBhcnQoaW5wdXQpIHtcbiAgICAgIG9wYWNpdHk6IDA7XG4gICAgICBjb2xvcjogdHJhbnNwYXJlbnQ7XG4gICAgICB3aWR0aDogMDtcbiAgICAgIHBhZGRpbmc6IDA7XG4gICAgICBmbGV4OiAxO1xuXG4gICAgICAmOjpwbGFjZWhvbGRlciB7XG4gICAgICAgIHZpc2liaWxpdHk6IGhpZGRlbjtcbiAgICAgIH1cblxuICAgICAgJjo6c2VsZWN0aW9uIHtcbiAgICAgICAgY29sb3I6IHZhcigtLWlkcy1jb2xvci10cmFuc3BhcmVudCk7XG4gICAgICAgIGJhY2tncm91bmQ6IHZhcigtLWlkcy1jb2xvci10cmFuc3BhcmVudCk7XG4gICAgICB9XG4gICAgfVxuXG4gICAgaWRzLXRleHQge1xuICAgICAgbWF4LXdpZHRoOiAxMDAlO1xuXG4gICAgICAmLnBsYWNlaG9sZGVyIHtcbiAgICAgICAgY29sb3I6IHZhcigtLWlkcy1tdWx0aXNlbGVjdC1zZWN0aW9uLWhlYWRlci1jb2xvcik7XG4gICAgICB9XG5cbiAgICAgICY6OnBhcnQodGV4dCkge1xuICAgICAgICBwYWRkaW5nLWlubGluZS1zdGFydDogdmFyKC0taWRzLXNwYWNlLXhzKTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmW2NvbXBhY3RdLFxuICAgICZbZmllbGQtaGVpZ2h0PSd4cyddIHtcbiAgICAgIGlkcy10ZXh0OjpwYXJ0KHRleHQpIHtcbiAgICAgICAgcGFkZGluZy1pbmxpbmUtc3RhcnQ6IHZhcigtLWlkcy1zcGFjZS0yeHMpO1xuICAgICAgICBmb250LXNpemU6IHZhcigtLWlkcy1tdWx0aXNlbGVjdC1mb250LXNpemUpO1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG46aG9zdCg6bm90KFt0YWdzXSkpIGlkcy10cmlnZ2VyLWZpZWxkIHtcbiAgaWRzLXRleHQucGxhY2Vob2xkZXIge1xuICAgIGNvbG9yOiB2YXIoLS1pZHMtbXVsdGlzZWxlY3Qtc2VjdGlvbi1oZWFkZXItY29sb3IpO1xuXG4gICAgJjo6cGFydCh0ZXh0KSB7XG4gICAgICBwYWRkaW5nLWlubGluZS1zdGFydDogMDtcbiAgICB9XG4gIH1cbn1cblxuOmhvc3QoLmRhdGFncmlkLWVkaXRvcikgaWRzLXRyaWdnZXItZmllbGQge1xuICBpZHMtdGV4dCB7XG4gICAgbWFyZ2luLWlubGluZS1zdGFydDogNXB4O1xuICB9XG59XG5cbjpob3N0KDpub3QoW2Rpc2FibGVkXSkpIHtcbiAgLmhhcy12YWx1ZSB7XG4gICAgaWRzLXRyaWdnZXItZmllbGQge1xuICAgICAgJjo6cGFydChmaWVsZC1jb250YWluZXIpIHtcbiAgICAgICAgY3Vyc29yOiB2YXIoLS1pZHMtY3Vyc29yLXBvaW50ZXIpO1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG46aG9zdChbZGlzYWJsZWRdKSB7XG4gIGlkcy10cmlnZ2VyLWZpZWxkIHtcbiAgICAmOjpwYXJ0KGZpZWxkLWNvbnRhaW5lcikge1xuICAgICAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG4gICAgfVxuICB9XG59XG5cbjpob3N0IHtcbiAgLnRyaWdnZXItaWNvbixcbiAgaWRzLXRyaWdnZXItYnV0dG9uIGlkcy1pY29uIHtcbiAgICBjb2xvcjogdmFyKC0taWRzLW11bHRpc2VsZWN0LWRyb3Bkb3duLWljb24tY29sb3IpO1xuICB9XG59XG5cbi5pcy1vcGVuIHtcbiAgaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQoZmllbGQtY29udGFpbmVyKSB7XG4gICAgYm94LXNoYWRvdzogdmFyKC0taWRzLW11bHRpc2VsZWN0LWRyb3Bkb3duLWJveC1zaGFkb3cpO1xuXG4gICAgJjpub3QoLmVycm9yKSB7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1pZHMtbXVsdGlzZWxlY3Qtb3Blbi1iYWNrZ3JvdW5kLWNvbG9yKTtcbiAgICAgIGJvcmRlcjogdmFyKC0taWRzLW11bHRpc2VsZWN0LWJvcmRlci1vcGVuKTtcbiAgICB9XG4gIH1cbn1cbiIsIi8qIElkcyBEcm9wZG93biBDb21wb25lbnQgKi9cbkB1c2UgJy4uLy4uL3RoZW1lcy9taXhpbnMvaWRzLXZhbGlkYXRpb24tbWl4aW4nO1xuQHVzZSAnLi4vLi4vdGhlbWVzL21peGlucy9pZHMtZXJyb3ItdHJhY2tlci1taXhpbicgYXMgKjtcbkB1c2UgJy4uLy4uL3RoZW1lcy9taXhpbnMvaWRzLWZpZWxkLWluZGljYXRvci1taXhpbicgYXMgKjtcblxuOmhvc3Qge1xuICAtLWlkcy1idXR0b24tdGVydGlhcnktY29sb3ItYmFja2dyb3VuZC1ob3ZlcjogdmFyKC0taWRzLWNvbG9yLXRyYW5zcGFyZW50KTtcbiAgLS1pZHMtYnV0dG9uLXRlcnRpYXJ5LWNvbG9yLWJvcmRlci1ob3ZlcjogdmFyKC0taWRzLWNvbG9yLXRyYW5zcGFyZW50KTtcbiAgLS1pZHMtYnV0dG9uLXRlcnRpYXJ5LWNvbG9yLWJhY2tncm91bmQtcHJlc3NlZDogdmFyKC0taWRzLWNvbG9yLXRyYW5zcGFyZW50KTtcbiAgLS1pZHMtYnV0dG9uLXRlcnRpYXJ5LWNvbG9yLWJvcmRlci1wcmVzc2VkOiB2YXIoLS1pZHMtY29sb3ItdHJhbnNwYXJlbnQpO1xuXG4gIGRpc3BsYXk6IGJsb2NrO1xuXG4gIC5pZHMtZHJvcGRvd24ge1xuICAgIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgICBtYXgtd2lkdGg6IDEwMCU7XG4gICAgd2lkdGg6IHZhcigtLWlkcy1ib3gtZHJvcGRvd24td2lkdGgsIGF1dG8pO1xuICB9XG59XG5cbjpob3N0KFtmaWVsZC1pbmRpY2F0b3JdKSB7XG4gIC0taWRzLWZpZWxkLWluZGljYXRvci1pbmZvLW1hcmdpbjogMDtcbn1cblxuOmhvc3QoW2ZpZWxkLWluZGljYXRvcl1bcmVhZG9ubHldKSxcbjpob3N0KFtmaWVsZC1pbmRpY2F0b3JdW2Rpc2FibGVkXSkge1xuICAtLWlkcy1maWVsZC1pbmRpY2F0b3ItaW5mby12aXNpYmlsaXR5OiBub25lO1xufVxuXG46aG9zdChbaGlkZGVuXSkge1xuICBkaXNwbGF5OiBub25lO1xufVxuXG46aG9zdChbbGFiZWwtcG9zaXRpb249XCJpbmxpbmUtc3RhcnRcIl0pIHtcbiAgaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQoY29udGFpbmVyKSB7XG4gICAganVzdGlmeS1jb250ZW50OiB2YXIoLS1pZHMtYm94LWp1c3RpZnktY29udGVudCwgZmxleC1zdGFydCk7XG4gIH1cbn1cblxuaWRzLXRyaWdnZXItZmllbGRbcmVhZG9ubHktYmFja2dyb3VuZF06bm90KFtkaXNhYmxlZF0pOjpwYXJ0KGlucHV0KSB7XG4gIGN1cnNvcjogdmFyKC0taWRzLWN1cnNvci1wb2ludGVyKTtcbn1cblxuaWRzLXRyaWdnZXItZmllbGQ6bm90KFthdXRvc2VsZWN0XSk6OnBhcnQoaW5wdXQpIHtcbiAgJjo6c2VsZWN0aW9uIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1pZHMtY29sb3ItdHJhbnNwYXJlbnQpO1xuICB9XG59XG5cbi8vIE1vc3QgU3R5bGVzIGFyZSBpbiBsaXN0LWJveCwgcG9wdXAgYW5kIHRyaWdnZXIgZmllbGRcbi5pZHMtZHJvcGRvd24ge1xuICBkaXNwbGF5OiBibG9jaztcbiAgcG9zaXRpb246IHJlbGF0aXZlO1xuXG4gIGlkcy10cmlnZ2VyLWZpZWxkIHtcbiAgICAmW3NpemU9J2Z1bGwnXSB7XG4gICAgICBkaXNwbGF5OiBibG9jaztcbiAgICB9XG4gIH1cblxuICAmLmZ1bGwge1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuXG4gICAgaWRzLXRyaWdnZXItZmllbGQsXG4gICAgLmlkcy10cmlnZ2VyLWZpZWxkIHtcbiAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIH1cbiAgfVxuXG4gIDo6c2xvdHRlZChpZHMtbGlzdC1ib3gpIHtcbiAgICBoZWlnaHQ6IHZhcigtLWlkcy1wb3B1cC1tYXhoZWlnaHQpO1xuICB9XG59XG5cbi8vIEljb24gUGxhY2VtZW50XG4udHJpZ2dlci1pY29uIHtcbiAgY29sb3I6IHZhcigtLWlkcy1kcm9wZG93bi1jb2xvci1pY29uKTtcbiAgbWFyZ2luOiAwIDAgMCB2YXIoLS1pZHMtZHJvcGRvd24tc3BhY2UtdGV4dCk7XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgdG9wOiAwO1xufVxuXG46aG9zdChbbW9kZT0nbGlnaHQnXSkge1xuICAudHlwZWFoZWFkLmlzLW9wZW4gaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQoZmllbGQtY29udGFpbmVyKSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0taWRzLWRyb3Bkb3duLXR5cGVhaGVhZC1jb2xvci1iYWNrZ3JvdW5kKTtcbiAgfVxufVxuXG46aG9zdChbZGlyPSdydGwnXSkgLnRyaWdnZXItaWNvbiB7XG4gIG1hcmdpbjogMCB2YXIoLS1pZHMtZHJvcGRvd24tc3BhY2UtdGV4dCkgMCAwO1xufVxuXG46OnNsb3R0ZWQoLnN1Yi1ncm91cCkge1xuICBib3JkZXItdG9wOiAxcHggc29saWQgdmFyKC0taWRzLWRyb3Bkb3duLXNlcGFyYXRvci1jb2xvci1ib3JkZXIpO1xuICBwYWRkaW5nLXRvcDogdmFyKC0taWRzLWRyb3Bkb3duLXNlcGFyYXRvci1wYWRkaW5nKTtcbn1cblxuLy8gRHJvcGRvd24gRWRpdG9yXG4uaWRzLWRyb3Bkb3duLmNvbG9yLXZhcmlhbnQtYm9yZGVybGVzcyxcbi5pZHMtZHJvcGRvd24uY29sb3ItdmFyaWFudC1pbi1jZWxsIHtcbiAgaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQoZmllbGQtY29udGFpbmVyKSB7XG4gICAgbWFyZ2luOiAwO1xuICAgIGJvcmRlci1yYWRpdXM6IDA7XG4gIH1cblxuICBpZHMtdHJpZ2dlci1maWVsZDo6cGFydChsYWJlbCkge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cblxuLy8gRHJvcGRvd24gRWRpdG9yIEJvcmRlcmxlc3Ncbi5pZHMtZHJvcGRvd24uY29sb3ItdmFyaWFudC1ib3JkZXJsZXNzIHtcbiAgaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQoY29udGFpbmVyKSB7XG4gICAgbWFyZ2luOiAtMXB4O1xuICB9XG5cbiAgaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQoZmllbGQtY29udGFpbmVyKSB7XG4gICAgYm94LXNoYWRvdzogbm9uZSAhaW1wb3J0YW50O1xuICB9XG5cbiAgJi5pcy1vcGVuIHtcbiAgICAuaWRzLXRyaWdnZXItZmllbGQtc2xvdC10cmlnZ2VyLWVuZCB7XG4gICAgICBtYXJnaW4tYmxvY2stc3RhcnQ6IDJweDtcbiAgICB9XG4gIH1cblxuICAmLmZpZWxkLWhlaWdodC1sZyB7XG4gICAgaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQoaW5wdXQpIHtcbiAgICAgIHBhZGRpbmctaW5saW5lOiAxMnB4O1xuICAgICAgaGVpZ2h0OiA1MHB4O1xuICAgIH1cblxuICAgICYuaXMtb3BlbiB7XG4gICAgICAuaWRzLXRyaWdnZXItZmllbGQtc2xvdC10cmlnZ2VyLWVuZCB7XG4gICAgICAgIG1hcmdpbi1pbmxpbmUtZW5kOiAzcHg7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgJi5maWVsZC1oZWlnaHQtbWQge1xuICAgIGlkcy10cmlnZ2VyLWZpZWxkOjpwYXJ0KGlucHV0KSB7XG4gICAgICBwYWRkaW5nLWlubGluZTogMTNweDtcbiAgICAgIGhlaWdodDogNDBweDtcbiAgICB9XG5cbiAgICAmLmlzLW9wZW4ge1xuICAgICAgLmlkcy10cmlnZ2VyLWZpZWxkLXNsb3QtdHJpZ2dlci1lbmQge1xuICAgICAgICBtYXJnaW4taW5saW5lLWVuZDogMTBweDtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAmLmZpZWxkLWhlaWdodC1zbSB7XG4gICAgaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQoaW5wdXQpIHtcbiAgICAgIHBhZGRpbmctaW5saW5lOiA5cHg7XG4gICAgICBoZWlnaHQ6IDM1cHg7XG4gICAgfVxuXG4gICAgJi5pcy1vcGVuIHtcbiAgICAgIC5pZHMtdHJpZ2dlci1maWVsZC1zbG90LXRyaWdnZXItZW5kIHtcbiAgICAgICAgbWFyZ2luLWlubGluZS1lbmQ6IDNweDtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAmLmZpZWxkLWhlaWdodC14cyB7XG4gICAgaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQoaW5wdXQpIHtcbiAgICAgIHBhZGRpbmctaW5saW5lOiA1cHg7XG4gICAgICBoZWlnaHQ6IDMwcHg7XG4gICAgfVxuXG4gICAgJi5pcy1vcGVuIHtcbiAgICAgIC5pZHMtdHJpZ2dlci1maWVsZC1zbG90LXRyaWdnZXItZW5kIHtcbiAgICAgICAgbWFyZ2luLWlubGluZS1lbmQ6IC0ycHg7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgJi5maWVsZC1oZWlnaHQteHhzIHtcbiAgICBpZHMtdHJpZ2dlci1maWVsZDo6cGFydChpbnB1dCkge1xuICAgICAgcGFkZGluZy1pbmxpbmU6IDNweDtcbiAgICAgIGhlaWdodDogMzBweDtcbiAgICB9XG5cbiAgICAmLmlzLW9wZW4ge1xuICAgICAgLmlkcy10cmlnZ2VyLWZpZWxkLXNsb3QtdHJpZ2dlci1lbmQge1xuICAgICAgICBtYXJnaW4taW5saW5lLWVuZDogLTFweDtcbiAgICAgICAgbWFyZ2luLWJsb2NrLXN0YXJ0OiAtMnB4O1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuXG46aG9zdChbY29tYm9ib3hdKSB7XG4gIC5pZHMtZHJvcGRvd24uY29sb3ItdmFyaWFudC1ib3JkZXJsZXNzIHtcbiAgICAuaWRzLXRyaWdnZXItZmllbGQtc2xvdC10cmlnZ2VyLWVuZCB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIG1hcmdpbi1ibG9jay1zdGFydDogMnB4O1xuICAgIH1cblxuICAgICYuZmllbGQtaGVpZ2h0LWxnIHtcbiAgICAgIC5pZHMtdHJpZ2dlci1maWVsZC1zbG90LXRyaWdnZXItZW5kIHtcbiAgICAgICAgbWFyZ2luLWlubGluZS1lbmQ6IDNweDtcbiAgICAgICAgaGVpZ2h0OiA0OHB4O1xuICAgICAgfVxuICAgIH1cblxuICAgICYuZmllbGQtaGVpZ2h0LW1kIHtcbiAgICAgIC5pZHMtdHJpZ2dlci1maWVsZC1zbG90LXRyaWdnZXItZW5kIHtcbiAgICAgICAgbWFyZ2luLWlubGluZS1lbmQ6IC0xcHg7XG4gICAgICAgIGhlaWdodDogMzlweDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmLmZpZWxkLWhlaWdodC1zbSB7XG4gICAgICAuaWRzLXRyaWdnZXItZmllbGQtc2xvdC10cmlnZ2VyLWVuZCB7XG4gICAgICAgIG1hcmdpbi1pbmxpbmUtZW5kOiAtNXB4O1xuICAgICAgICBoZWlnaHQ6IDMzcHg7XG4gICAgICB9XG4gICAgfVxuXG4gICAgJi5maWVsZC1oZWlnaHQteHMge1xuICAgICAgLmlkcy10cmlnZ2VyLWZpZWxkLXNsb3QtdHJpZ2dlci1lbmQge1xuICAgICAgICBtYXJnaW4taW5saW5lLWVuZDogLTEwcHg7XG4gICAgICAgIGhlaWdodDogMjlweDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmLmZpZWxkLWhlaWdodC14eHMge1xuICAgICAgLmlkcy10cmlnZ2VyLWZpZWxkLXNsb3QtdHJpZ2dlci1lbmQge1xuICAgICAgICBtYXJnaW4taW5saW5lLWVuZDogLTEwcHg7XG4gICAgICAgIG1hcmdpbi1ibG9jay1zdGFydDogMDtcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cblxuLy8gRHJvcGRvd24gRWRpdG9yIEluIENlbGxcbi5pZHMtZHJvcGRvd24uY29sb3ItdmFyaWFudC1pbi1jZWxsIHtcbiAgaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQoY29udGFpbmVyKSB7XG4gICAgbWFyZ2luOiAxcHggMDtcbiAgfVxufVxuXG4vLyBNb2R1bGUgTmF2IENvbG9yIFZhcmlhbnRcbi5pZHMtZHJvcGRvd24uY29sb3ItdmFyaWFudC1tb2R1bGUtbmF2IHtcbiAgY29sb3I6IHZhcigtLWlkcy1tb2R1bGUtbmF2LXNlYXJjaC1pbnB1dC10ZXh0LWNvbG9yKTtcbiAgZGlzcGxheTogYmxvY2s7XG4gIG1hcmdpbi1ibG9jay1lbmQ6IDA7XG5cbiAgOjpzbG90dGVkKGlkcy1saXN0LWJveCkge1xuICAgIGNvbG9yOiB2YXIoLS1pZHMtbW9kdWxlLW5hdi1zZWFyY2gtaW5wdXQtdGV4dC1jb2xvcik7XG4gIH1cblxuICA6OnNsb3R0ZWQoaWRzLWxpc3QtYm94LW9wdGlvbikge1xuICAgIGNvbG9yOiBpbmhlcml0O1xuICB9XG5cbiAgaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQoZmllbGQtY29udGFpbmVyKSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0taWRzLW1vZHVsZS1uYXYtaW5wdXQtYmctY29sb3IpO1xuICAgIGJvcmRlci1yYWRpdXM6IHZhcigtLWlkcy1tb2R1bGUtbmF2LWNvbW1vbi1ib3JkZXItcmFkaXVzKTtcbiAgICBib3JkZXI6IHZhcigtLWlkcy1tb2R1bGUtbmF2LWlucHV0LWJvcmRlci13aWR0aCkgc29saWQgdmFyKC0taWRzLW1vZHVsZS1uYXYtaW5wdXQtYm9yZGVyLWNvbG9yKTtcbiAgICBib3gtc2hhZG93OiBub25lO1xuICAgIGNvbG9yOiBpbmhlcml0O1xuICAgIG92ZXJmbG93OiBoaWRkZW47XG4gIH1cblxuICBpZHMtdHJpZ2dlci1maWVsZDpob3Zlcjo6cGFydChmaWVsZC1jb250YWluZXIpIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1pZHMtbW9kdWxlLW5hdi1pbnB1dC1ob3Zlci1iZy1jb2xvcik7XG4gIH1cblxuICBpZHMtdHJpZ2dlci1maWVsZDphY3RpdmU6OnBhcnQoZmllbGQtY29udGFpbmVyKSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0taWRzLW1vZHVsZS1uYXYtaXRlbS1zZWxlY3RlZC1iZy1jb2xvcik7XG4gICAgYm9yZGVyLWNvbG9yOiB2YXIoLS1pZHMtbW9kdWxlLW5hdi1pdGVtLXNlbGVjdGVkLXRleHQtY29sb3IpO1xuICAgIGNvbG9yOiB2YXIoLS1pZHMtbW9kdWxlLW5hdi1pdGVtLXNlbGVjdGVkLXRleHQtY29sb3IpO1xuICB9XG5cbiAgaWRzLXRyaWdnZXItZmllbGQ6Zm9jdXMtd2l0aGluOjpwYXJ0KGZpZWxkLWNvbnRhaW5lcikge1xuICAgIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWlkcy1tb2R1bGUtbmF2LWlucHV0LWZvY3VzLWJnLWNvbG9yKTtcbiAgfVxuXG4gIGlkcy10cmlnZ2VyLWZpZWxkOjpwYXJ0KGlucHV0KSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0taWRzLWNvbG9yLXRyYW5zcGFyZW50KTtcbiAgICBjb2xvcjogaW5oZXJpdDtcbiAgfVxuXG4gIGlkcy10cmlnZ2VyLWZpZWxkOjpwYXJ0KHRyaWdnZXItYnV0dG9uKSB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdmFyKC0taWRzLWNvbG9yLXRyYW5zcGFyZW50KTtcbiAgfVxuXG4gIGlkcy10cmlnZ2VyLWZpZWxkOjpwYXJ0KGlucHV0OjpwbGFjZWhvbGRlcikge1xuICAgIGNvbG9yOiB2YXIoLS1pZHMtbW9kdWxlLW5hdi1zZWFyY2gtaW5wdXQtcGxhY2Vob2xkZXItdGV4dC1jb2xvcik7XG4gIH1cblxuICBpZHMtdHJpZ2dlci1maWVsZDo6cGFydChpbnB1dDphY3RpdmUpIHtcbiAgICBjb2xvcjogdmFyKC0taWRzLW1vZHVsZS1uYXYtc2VhcmNoLWlucHV0LXRleHQtY29sb3IpO1xuICB9XG5cbiAgaWRzLWRyb3Bkb3duLWxpc3Q6OnBhcnQoZHJvcGRvd24tbGlzdCkge1xuICAgIG1heC13aWR0aDogdmFyKC0taWRzLW1vZHVsZS1uYXYtZXhwYW5kZWQtc2l6ZSk7XG4gICAgd2lkdGg6IGNhbGModmFyKC0taWRzLW1vZHVsZS1uYXYtc3dpdGNoZXItZHJvcGRvd24td2lkdGgpICsgdmFyKC0taWRzLW1vZHVsZS1uYXYtc3dpdGNoZXItYnV0dG9uLWd1dHRlci1zaXplKSArIHZhcigtLWlkcy1tb2R1bGUtbmF2LXN3aXRjaGVyLWJ1dHRvbi1zaXplKSk7XG4gIH1cblxuICBpZHMtbGlzdC1ib3gtb3B0aW9uIHtcbiAgICBtaW4taGVpZ2h0OiB2YXIoLS1pZHMtbW9kdWxlLW5hdi1pdGVtLWhlaWdodCk7XG4gIH1cblxuICAuZmllbGRzZXQge1xuICAgIGRpc3BsYXk6IGNvbnRlbnRzO1xuICB9XG5cbiAgLmlkcy1pbnB1dC1maWVsZCB7XG4gICAgcGFkZGluZy1pbmxpbmUtc3RhcnQ6IHZhcigtLWlkcy1tb2R1bGUtbmF2LWl0ZW0tZXhwYW5kZWQtaWNvbi10ZXh0LXNwYWNlLXNpemUpO1xuICB9XG59XG5cbi8vIERyb3Bkb3duIG1lbnUgd2lkdGhcbjpob3N0IGlkcy1kcm9wZG93bi1saXN0IHtcbiAgbWF4LXdpZHRoOiB2YXIoLS1pZHMtaW5wdXQtd2lkdGgtNDApO1xufVxuXG46aG9zdChbc2l6ZT0neHMnXSkgaWRzLWRyb3Bkb3duLWxpc3Qge1xuICBtYXgtd2lkdGg6IHZhcigtLWlkcy1pbnB1dC13aWR0aC0xMCk7XG59XG5cbjpob3N0KFtzaXplPSdzbSddKSBpZHMtZHJvcGRvd24tbGlzdCB7XG4gIG1heC13aWR0aDogdmFyKC0taWRzLWlucHV0LXdpZHRoLTIwKTtcbn1cblxuOmhvc3QoW3NpemU9J21tJ10pIGlkcy1kcm9wZG93bi1saXN0IHtcbiAgbWF4LXdpZHRoOiB2YXIoLS1pZHMtaW5wdXQtd2lkdGgtMzApO1xufVxuXG46aG9zdChbc2l6ZT0nbWQnXSkgaWRzLWRyb3Bkb3duLWxpc3Qge1xuICBtYXgtd2lkdGg6IHZhcigtLWlkcy1pbnB1dC13aWR0aC00MCk7XG59XG5cbjpob3N0KFtzaXplPSdsZyddKSBpZHMtZHJvcGRvd24tbGlzdCB7XG4gIG1heC13aWR0aDogdmFyKC0taWRzLWlucHV0LXdpZHRoLTUwKTtcbn1cblxuOmhvc3QoW3NpemU9J2Z1bGwnXSkgaWRzLWRyb3Bkb3duLWxpc3Qge1xuICBtYXgtd2lkdGg6IHZhcigtLWlkcy1pbnB1dC13aWR0aC1mdWxsKTtcbn1cblxuOmhvc3QgaWRzLWRyb3Bkb3duLWxpc3QsXG46aG9zdChbc2l6ZT0nZnVsbCddKSB7XG4gIHdpZHRoOiB2YXIoLS1pZHMtaW5wdXQtd2lkdGgtZnVsbCk7XG59XG5cbi8vIENoYW5nZSBzdGF0ZSBmb3IgZXh0ZXJuYWwgZHJvcGRvd24gbGlzdFxuOmhvc3QoW2xpc3RdOm5vdChbZGlzYWJsZWRdKSkge1xuICBjdXJzb3I6IHZhcigtLWlkcy1jdXJzb3ItcG9pbnRlcik7XG59XG5cbjpob3N0KFthdXRvLXNpemU9XCJ0cnVlXCJdKSB7XG4gIGlkcy10cmlnZ2VyLWZpZWxkOjpwYXJ0KGlucHV0KSB7XG4gICAgcGFkZGluZy1pbmxpbmUtZW5kOiAwO1xuICB9XG59XG4iLCJAdXNlICcuLi8uLi90aGVtZXMvbWl4aW5zL2lkcy1jb3JlLW1peGlucycgYXMgbWl4aW5zO1xuXG4udmFsaWRhdGlvbi1tZXNzYWdlIHtcbiAgQGluY2x1ZGUgbWl4aW5zLmFudGlhbGlhc2VkKCk7XG5cbiAgZGlzcGxheTogZmxleDtcbiAgZm9udC1mYW1pbHk6IHZhcigtLWlkcy1mb250LWZhbWlseS1kZWZhdWx0KSwgdmFyKC0taWRzLWZvbnQtZmFtaWx5LXN5c3RlbS1zYW5zKTtcbiAgbWFyZ2luLXRvcDogdmFyKC0taWRzLXNwYWNlLTJ4cyk7XG4gIG1heC13aWR0aDogdmFyKC0taWRzLWlucHV0LXdpZHRoLWZ1bGwpO1xuXG4gICYuaGFzLWN1c3RvbS1pY29uIHtcbiAgICBjb2xvcjogdmFyKC0taWRzLWljb24tY29sb3ItZGVmYXVsdCk7XG4gIH1cblxuICAmLmRpc2FibGVkIHtcbiAgICBjb2xvcjogdmFyKC0taWRzLWlucHV0LWNvbG9yLXRleHQtZGlzYWJsZWQpO1xuICB9XG5cbiAgLmlkcy1pY29uIHtcbiAgICBtYXJnaW4taW5saW5lLWVuZDogdmFyKC0taWRzLXNwYWNlLTJ4cyk7XG4gIH1cblxuICAmLmFsZXJ0IHtcbiAgICBjb2xvcjogdmFyKC0taWRzLWNvbG9yLWNhdXRpb24tZGVmYXVsdCk7XG5cbiAgICAmLmRpc2FibGVkIHtcbiAgICAgIGNvbG9yOiB2YXIoLS1pZHMtY29sb3IteWVsbG93LTMwKTtcbiAgICB9XG4gIH1cblxuICAmLndhcm5pbmcge1xuICAgIGNvbG9yOiB2YXIoLS1pZHMtY29sb3Itd2FybmluZy1kZWZhdWx0KTtcblxuICAgICYuZGlzYWJsZWQge1xuICAgICAgY29sb3I6IHZhcigtLWlkcy1jb2xvci1vcmFuZ2UtMzApO1xuICAgIH1cbiAgfVxuXG4gICYuZXJyb3Ige1xuICAgIGNvbG9yOiB2YXIoLS1pZHMtY29sb3ItZXJyb3ItZGVmYXVsdCk7XG5cbiAgICAmLmRpc2FibGVkIHtcbiAgICAgIGNvbG9yOiB2YXIoLS1pZHMtY29sb3ItcmVkLTMwKTtcbiAgICB9XG4gIH1cblxuICAmLmluZm8ge1xuICAgIGNvbG9yOiB2YXIoLS1pZHMtY29sb3ItaW5mby1kZWZhdWx0KTtcblxuICAgICYuZGlzYWJsZWQge1xuICAgICAgY29sb3I6IHZhcigtLWlkcy1jb2xvci1ibHVlLTMwKTtcbiAgICB9XG4gIH1cblxuICAmLnN1Y2Nlc3Mge1xuICAgIGNvbG9yOiB2YXIoLS1pZHMtY29sb3Itc3VjY2Vzcy1kZWZhdWx0KTtcblxuICAgICYuZGlzYWJsZWQge1xuICAgICAgY29sb3I6IHZhcigtLWlkcy1jb2xvci1ncmVlbi0zMCk7XG4gICAgfVxuICB9XG5cbiAgJltoaWRkZW5dIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbjpob3N0KFtzdXBwcmVzcy1lcnJvci1tZXNzYWdlXSkge1xuICAudmFsaWRhdGlvbi1tZXNzYWdlIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG4iLCIvLyBCcmVha3BvaW50cyAtIHRoaXMgY2FudCBiZSB0b2tlbnNcbiRicmVha3BvaW50LXh4bDogMjQ2M3B4O1xuJGJyZWFrcG9pbnQteGw6IDExODNweDtcbiRicmVha3BvaW50LWxnOiA5MjhweDtcbiRicmVha3BvaW50LW1kOiA5MjdweDtcbiRicmVha3BvaW50LXNtOiA3NjdweDtcbiRicmVha3BvaW50LXhzOiAzMjBweDtcblxuLy8gU2V0cyBUZXh0IEFudGlhbGlhc2luZ1xuQG1peGluIGFudGlhbGlhc2VkIHtcbiAgLXdlYmtpdC1mb250LXNtb290aGluZzogYW50aWFsaWFzZWQ7XG4gIC1tb3otb3N4LWZvbnQtc21vb3RoaW5nOiBncmF5c2NhbGU7XG59XG5cbi8vIHZlbmRvciBwcmVmaXhlZCB0cmFuc2l0aW9ucyBmb3IgcmVndWxhciBhdHRyaWJ1dGVzIChub24tdmVuZG9yIHByZWZpeGVkKVxuQG1peGluIHRyYW5zaXRpb24oJHRyYW5zaXRpb25zLWxpc3QuLi4pIHtcbiAgQGVhY2ggJHByZWZpeCBpbiAkcHJlZml4ZXMge1xuICAgICN7JHByZWZpeH10cmFuc2l0aW9uOiAkdHJhbnNpdGlvbnMtbGlzdDtcbiAgfVxufVxuXG4vLyBtYWtlIHRoZSB0ZXh0IGludmlzaWJsZSB2aXN1YWxseSBidXQgcmVhZGFibGUgYnkgc2NyZWVuIHJlYWRlcnNcbkBtaXhpbiBhdWRpYmxlKCkge1xuICAvKiBzdHlsZWxpbnQtZGlzYWJsZS1uZXh0LWxpbmUgcHJvcGVydHktbm8tZGVwcmVjYXRlZCAqL1xuICBjbGlwOiByZWN0KDAsIDAsIDAsIDApO1xuICBoZWlnaHQ6IDA7XG4gIGxpbmUtaGVpZ2h0OiAwO1xuICBtaW4taGVpZ2h0OiAwO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICBwYWRkaW5nOiAwO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHdpZHRoOiAxcHg7XG59XG4iLCIvLyBHZW5lcmFsIEVycm9yLVRyYWNrZXIgaWNvbiBwbGFjZW1lbnRcbi5pY29uLWVycm9yLXRyYWNrZXIge1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGNvbG9yOiB2YXIoLS1pZHMtaW5wdXQtZXJyb3ItdHJhY2tlci1jb2xvci1iYWNrZ3JvdW5kLCB2YXIoLS1pZHMtY29sb3ItcmVkLTYwKSk7XG4gIHRvcDogMDtcbiAgcG9pbnRlci1ldmVudHM6IG5vbmU7XG5cbiAgJltkaXI9J3J0bCddIHtcbiAgICB0cmFuc2Zvcm06IHJvdGF0ZSg5MGRlZyk7XG4gICAgdG9wOiAwO1xuICB9XG59XG4iLCIvLyBGaWVsZCBJbmRpY2F0b3IgaWNvbiBwbGFjZW1lbnRcbi5pY29uLWZpZWxkLWluZGljYXRvciB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwO1xuICBwb2ludGVyLWV2ZW50czogbm9uZTtcblxuICAmW2Rpcj0ncnRsJ10ge1xuICAgIHRyYW5zZm9ybTogcm90YXRlKDkwZGVnKTtcbiAgICB0b3A6IDA7XG4gIH1cbn1cblxuLmljb24tZmllbGQtaW5kaWNhdG9yLWluZm8ge1xuICBkaXNwbGF5OiB2YXIoLS1pZHMtZmllbGQtaW5kaWNhdG9yLWluZm8tdmlzaWJpbGl0eSwgZmxleCk7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIG1hcmdpbi1pbmxpbmUtZW5kOiB2YXIoLS1pZHMtZmllbGQtaW5kaWNhdG9yLWluZm8tbWFyZ2luLCB2YXIoLS1pZHMtc3BhY2UteHMpKTtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICBjb2xvcjogdmFyKC0taWRzLWZpZWxkLWluZGljYXRvci1pY29uLWNvbG9yLCAtLWlkcy1jb2xvci1pbmZvLWRlZmF1bHQpO1xufVxuXG4vLyBNaXhpbiB0byBhcHBseSBmaWVsZCBpbmRpY2F0b3IgY29sb3IgdmFyaWFibGVzXG5AbWl4aW4gZmllbGQtaW5kaWNhdG9yLWNvbG9yKCRjb2xvciwgJGJvcmRlci1jb2xvcjogbnVsbCkge1xuICAtLWlkcy1maWVsZC1pbmRpY2F0b3ItaWNvbi1jb2xvcjogI3skY29sb3J9O1xuXG4gIEBpZiAkYm9yZGVyLWNvbG9yIHtcbiAgICAtLWlkcy1pbnB1dC1ib3JkZXItZGVmYXVsdC1jb2xvcjogI3skYm9yZGVyLWNvbG9yfTtcbiAgICAtLWlkcy1pbnB1dC1jb2xvci1ib3JkZXItaG92ZXI6ICN7JGJvcmRlci1jb2xvcn07XG4gICAgLS1pZHMtaW5wdXQtY29sb3ItYm9yZGVyLWRpc2FibGVkOiAjeyRib3JkZXItY29sb3J9O1xuICAgIC0taWRzLWlucHV0LWNvbG9yLWJvcmRlci1mb2N1czogI3skYm9yZGVyLWNvbG9yfTtcbiAgfVxuXG4gIC5pY29uLWZpZWxkLWluZGljYXRvciB7XG4gICAgY29sb3I6ICN7JGNvbG9yfTtcbiAgfVxufVxuXG4vLyBGaWVsZCBpbmRpY2F0b3IgdHlwZSBjbGFzc2VzIOKAlCBhcHBsaWVkIHRvIHRoZSBmaWVsZCBjb250YWluZXIuXG4uZmllbGQtaW5kaWNhdG9yLW5ldXRyYWwge1xuICBAaW5jbHVkZSBmaWVsZC1pbmRpY2F0b3ItY29sb3IodmFyKC0taWRzLWNvbG9yLWFjY2VudC1uZXV0cmFsLXdlYWspKTtcbn1cblxuLmZpZWxkLWluZGljYXRvci1pbmZvIHtcbiAgQGluY2x1ZGUgZmllbGQtaW5kaWNhdG9yLWNvbG9yKHZhcigtLWlkcy1jb2xvci1pbmZvLWRlZmF1bHQpKTtcbn1cblxuLmZpZWxkLWluZGljYXRvci1zdWNjZXNzIHtcbiAgQGluY2x1ZGUgZmllbGQtaW5kaWNhdG9yLWNvbG9yKHZhcigtLWlkcy1jb2xvci1zdWNjZXNzLWRlZmF1bHQpKTtcbn1cblxuLmZpZWxkLWluZGljYXRvci1jYXV0aW9uIHtcbiAgQGluY2x1ZGUgZmllbGQtaW5kaWNhdG9yLWNvbG9yKHZhcigtLWlkcy1jb2xvci1jYXV0aW9uLWRlZmF1bHQpKTtcbn1cblxuLmZpZWxkLWluZGljYXRvci13YXJuaW5nIHtcbiAgQGluY2x1ZGUgZmllbGQtaW5kaWNhdG9yLWNvbG9yKHZhcigtLWlkcy1jb2xvci13YXJuaW5nLWRlZmF1bHQpKTtcbn1cblxuLmZpZWxkLWluZGljYXRvci1lcnJvciB7XG4gIEBpbmNsdWRlIGZpZWxkLWluZGljYXRvci1jb2xvcih2YXIoLS1pZHMtY29sb3ItZXJyb3ItZGVmYXVsdCkpO1xufVxuXG5bY2xhc3MqPVwiZmllbGQtaW5kaWNhdG9yLVwiXS5oYXMtZm9jdXMge1xuICAuaWNvbi1maWVsZC1pbmRpY2F0b3ItaW5mbyB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuIl19 */`;
